import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import { ref, computed, ComputedRef, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { User } from 'types';
import { isIOSChrome } from '@/plugins';
import InputComponent from '@/views/components/InputComponent.vue';
import EmailConfirmComponent from './EmailConfirmComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInComponent',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

const emailRef = ref<InstanceType<typeof InputComponent>>(null);
const form = ref<User.SignInForm>(new User.SignInForm());

const termsLinkByLocale = computed(() => 
  store.getters['support/termsLinkByLocale']
);
const privacyPolicyLinkByLocale = computed(() => 
  store.getters['support/privacyPolicyLinkByLocale']
);

const isSubmitEnable: ComputedRef<boolean> = computed(
  () => form.value.email.value.length > 0
);

function getRequestParams() {
  if (!form.value.isValid()) {
    return null
  }

  return form.value.createRequestBody()
}

function onFocus() {
  if (isIOSChrome() && emailRef.value?.input) {
    emailRef.value.input?.scrollIntoView({ behavior: 'smooth' });
  }

  return form.value.createRequestBody();
}

function onChangeEmail() {
  nextTick(() => {
    if (emailRef.value?.input?.focus) {
      emailRef.value.input.focus();
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(EmailConfirmComponent, {
    isSubmitEnable: _unref(isSubmitEnable),
    email: form.value.email.value,
    getRequestParams: getRequestParams,
    onError: (message) => form.value.email.error = message,
    onOnChangeEmail: onChangeEmail
  }, {
    formfields: _withCtx(({isLoading}) => [
      _createVNode(InputComponent, {
        ref_key: "emailRef",
        ref: emailRef,
        name: "email",
        type: "email",
        placeholder: _unref(t)('authModal.emailFieldPlaceholder'),
        value: form.value.email.value,
        validate: form.value.email.validationEnabled,
        readonly: isLoading,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (onFocus())),
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => {
          form.value.email.value = $event;
          form.value.email.validate();
        }),
        onChange: _cache[2] || (_cache[2] = ($event: any) => (form.value.email.validationEnabled = true)),
        errorText: form.value.email.error
      }, null, 8, ["placeholder", "value", "validate", "readonly", "errorText"])
    ]),
    policy: _withCtx(() => [
      _createVNode(_component_i18n_t, {
        keypath: "authModal.signInPrivacy",
        tag: "span",
        scope: "global"
      }, {
        terms: _withCtx(() => [
          _createElementVNode("a", {
            href: _unref(termsLinkByLocale),
            target: "_blank",
            class: "grey",
            rel: "noopener"
          }, _toDisplayString(_unref(t)('terms')), 9, _hoisted_1)
        ]),
        privacy: _withCtx(() => [
          _createElementVNode("a", {
            href: _unref(privacyPolicyLinkByLocale),
            target: "_blank",
            class: "grey",
            rel: "noopener"
          }, _toDisplayString(_unref(t)('privacy')), 9, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["isSubmitEnable", "email", "onError"]))
}
}

})